import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { TransactionDetail } from "@/type/core/transaction/transaction.types";
import CardSection from "@components/core/section/CardSection";
import LinkButton from "@components/core/links/LinkButton";
import { ROUTES } from "@routes/Routes";

interface ProcessSignatureSectionProps {
  transaction: TransactionDetail;
  className?: string;
}

const ProcessSignatureSection: FunctionComponent<
  ProcessSignatureSectionProps
> = ({ transaction, className = "" }) => {
  const { t } = useTranslation();

  return (
    <CardSection
      title={t("process.signature.title")}
      titleClassName="h1 mb-8"
      className={`app-section-process-signature ${className}`}
    >
      <>
        <p className="text-success">{t("process.signature.success")}</p>
        <p>{t("process.signature.successDescription")}</p>
        <div className="d-flex justify-content-center flex-wrap mt-24">
          <LinkButton
            to={ROUTES.extranet.home.generate()}
            variant="tertiary"
            className="mt-24 mx-24 py-8 px-30 mh-42 font-extra-small"
            text={t("process.signature.back")}
          />
          <LinkButton
            to={ROUTES.extranet.transactions.details.generate(transaction.id)}
            variant="tertiary"
            className="mt-24 mx-24 py-8 px-30 mh-42 font-extra-small"
            text={t("process.signature.toTransaction")}
          />
        </div>
      </>
    </CardSection>
  );
};

export default ProcessSignatureSection;
